import store from "../../../store";
import instructions from './instructions.vue';


window.INSTRUCTIONS =  new Vue({
    store,
    el: '#instructions',
    name : "INSTRUCTIONS",
    created () {

    },
    components : {
        instructions
    }
})
